import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AccountRecovery from './pages/AccountRecovery';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AccountRecovery />} />
      </Routes>
    </Router>
  );
}

export default App;
